import styled from 'styled-components';

export const LoadingStyled = styled.aside`
  ${({ shouldHideContent }) =>
    shouldHideContent && {
      position: 'absolute',
      top: 0,
      bottom: 0,
    }}
  z-index: 1;
  right: -24px;
  left: -24px;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LoadingTextStyled = styled.span`
  margin-top: 24px;
`;
